import React from 'react';

import { convertCurrency, currencyMaker } from 'services/helpers'

const tableCellStyles = {
  border: '1px solid #b9b9b9',
  padding: '2px'
};

export const BookingsSumSheetRow = ({
  routeName, departureDate, from, to, surname, name, phone, price, sourceId,
  setPricesPl, setPricesUa, setPricesCz, i, fromCityTypeByLabel, convert
}) => {
  const currency = currencyMaker(fromCityTypeByLabel, price, sourceId)
  const displayedPrice = convert ? convertCurrency(price, currency) : price

  /* eslint-disable */
  if (!isNaN(+displayedPrice)) {
    switch (currency) {
      case 'грн':
        setPricesUa(prevState => ([
          ...prevState,
          +displayedPrice
        ]));
        break;
      case 'zl':
        setPricesPl(prevState => ([
          ...prevState,
          +displayedPrice
        ]));
        break;
      case 'czk':
        setPricesCz(prevState => ([
          ...prevState,
          +displayedPrice
        ]));
        break;
    }
  }
  /* eslint-enable */

  return (
    <tr key={i}>
      <td style={tableCellStyles}>{i}</td>
      <td style={tableCellStyles}>{departureDate}</td>
      <td style={tableCellStyles}>{routeName}</td>
      <td style={tableCellStyles}>{from}</td>
      <td style={tableCellStyles}>{to}</td>
      <td style={tableCellStyles}>{surname}</td>
      <td style={tableCellStyles}>{name}</td>
      <td style={tableCellStyles}>{phone}</td>
      <td style={tableCellStyles}>{displayedPrice} {currency}</td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/BookingsSumSheet/components/BookingsSumSheetRow/BookingsSumSheetRow.js